import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Paper } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { saveAs } from "file-saver";

// Animation
import Information from "../Information/Information";
import QuestionModal from "../QuestionsModal/QuestionsModal";
import kaudiAnimation from "../../assets/lottieAnimation/Kaudies.json";
import car from "../../assets/lottieAnimation/JSON Data/CarLeft.json";
import bus from "../../assets/lottieAnimation/JSON Data/BusLeft.json";
import flight from "../../assets/lottieAnimation/JSON Data/FlightLeft.json";
import truck from "../../assets/lottieAnimation/JSON Data/TruckLeft.json";
import train from "../../assets/lottieAnimation/JSON Data/TrainRight.json";

// Custom Styled
import {
  Box,
  GamePad,
  MatchBoxStrip,
  BottomView,
  BottomText,
  Container,
  DiceButton,
  KaudiImage,
  RoomImage,
  TransparentBackground,
  ShowMessageSection,
  TutorialContentArea,
  ContainerTwo,
  CollectionImage,
  RoomCollectionImage,
  LottieAnimation,
  BazaarName,
  TutorialContentArea2,
  MatchBoxStripArea,
  MatchBoxStripButton,
  BottomTextTwo,
  BottomTextArea,
  CollectionArea,
  RoomParentDiv,
  Buttons,
  ModalButton,
  Door,
  ImageStyle,
  P,
  Para,
  Div,
  TextDiv,
  ContainerDiv,
  MarketDiv,
  Button,
  ButtonImg,
  OuterDiv,
} from "./GameStyle";
import "./Game.css";

// Images/Components
import { checkBrowser } from "../../component/commonFunctions";
import values from "../../stringValues";
import rollDiceTextValue from "../../rollDiceValues.json";
import {
  generateRandomNumber,
  playSound,
  randomArtImage,
  AxlTracker,
  loadImage,
} from "../../utils";
import { Board } from "../../typeOfboard";
import {
  kaudiOneSound,
  planeSound,
  truckSound,
  walkingSound,
  bazaarOneSound,
  quizStartSound,
  celebrationSound,
  collectionAddedToRoomTwoSound,
  carSound,
  busSound,
  trainSound,
} from "../../assets/audio/audio";
import thinking from "../../assets/lottieAnimation/Thinking.json";
import { images as imageValues } from "../../imageValues";
import Message from "../../component/Message/Message";

// Actions
import { playPauseSound } from "../../actions/playPauseSoundAction";
import { changeLanguage } from "../../actions/changeLanguageAction";

// Pages
import Instruction from "../Instruction/Instruction";

// AXL
import { useAxL } from "../../AxLContext";
import AxL from "../../axl";
import FiddleOne from "../FiddleOne/FiddleOne";
import stringValues from "../../stringValues";
import { CenterAbout } from "../Information/InformationStyle";

const numberOfBox = 8;
const initialAxis = {
  translateXOne: 0,
  translateXTwo: 0,
  translateYOne: 0,
};
const Game = ({
  boardName,
  onGameComplete,
  playPauseSound,
  playPauseSoundState,
  changeLanguage,
  changeLanguageState,
  setInfo,
  getInfo,
  showButton,
  randomArtworkState,
  getInstruction,
  setInstruction,
}) => {
  const axl = useAxL();
  const postion = useMemo(
    () => [
      { left: "1%", top: "1%" },
      { left: "11%", top: "1%" },
      { left: "22%", top: "1%" },
      { left: "33%", top: "1%" },
      { left: "44%", top: "1%" },
      { left: "55%", top: "1%" },
      { left: "66%", top: "1%" },
      { left: "77%", top: "1%" },
      { left: "88%", top: "1%" },
      { left: "6%", top: "25%" },
      { left: "17%", top: "25%" },
      { left: "28%", top: "25%" },
      { left: "55%", top: "25%" },
      { left: "66%", top: "25%" },
      { left: "77%", top: "25%" },
      { left: "88%", top: "25%" },
      { left: "11%", top: "50%" },
      { left: "78%", top: "50%" },
    ],
    []
  );

  const data = [
    imageValues.ORIENTATION,
    imageValues.SHARE,
    imageValues.DOWNLOAD,
    imageValues.RELOAD,
  ];
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);
  const [vehicleIndex, setVehicleIndex] = useState([]);
  const [initialState, setInitialState] = useState(true);
  const [marketIndex, setMarketIndex] = useState({});
  const [questionRound, setQuestionRound] = useState(1);
  const [questionState, setQuestionState] = useState([]);
  const [questionNo, setQuestionNo] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [showInstruction, setShowInstruction] = useState(false);
  const [movingAnimation, setMovingAnimation] = useState(false);
  const [downloadImage, setDownloadImage] = useState("");
  const [count, setCount] = useState(0);
  const [questionModal, setQuestionModal] = useState({
    questionObject: {},
    visible: false,
  });
  const [showMessage, setShowMessage] = useState(false);
  const [kaudiImage, setKaudiImage] = useState(imageValues.ROLLSIX);
  const [collectionImage, setCollectionImage] = useState([]);
  const [collectionImagesWithoutTape, setCollectionImagesWithoutTape] =
    useState([]);
  const [showKaudiAnimation, setShowKaudiAnimation] = useState(false);
  const [gameCompleteModal, setGameCompleteModal] = useState(false);
  const [gameCompleteQuote, setGameCompleteQuote] = useState(false);
  const [animationType, setAnimationType] = useState();
  const [vehicleType, setVehcileType] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [buildingCollection, setBuildingCollection] = useState(false);
  const [allQuizeCompleted, setAllQuizeCompleted] = useState(false);
  const [collectioArea, setCollectioArea] = useState(false);
  const [axis, setAxis] = useState(initialAxis);
  const [rollDiceText, setRollDiceText] = useState("");
  const isiOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const [randomImage, setRandomImage] = useState("");
  const [showDropDownLanguage, SetshowDropDownLanguage] = useState(false);
  const [collectedImageId, setCollectedImageId] = useState();
  const isMobileView = mobileWidth > 1080;
  const [onClickFirstTime, setOnClickFirstTime] = useState(false);
  const [firstShow, setFirstShow] = useState(0);
  const [kaudiTap, setKaudiTap] = useState(0);

  useEffect(() => {
    if (randomArtworkState.data !== null) {
      const data = randomArtImage(randomArtworkState.data, boardName);
      setRandomImage(data);
    }
  }, [randomArtworkState]);

  useEffect(() => {
    // setGameCompleteModal(true);
    // const getValue = getRollDiceText();
    // setRollDiceText(getValue);
    setCollector(1);
    getVehcilePosition();
    setKaudiImage(imageValues.ROLLSIX);
    setQuestionRound(1);
    setQuestionState([]);
    setVehcileType("");
    setAxis(initialAxis);
    setCollectionImagesWithoutTape([
      // {
      //   HD: imageValues.BOARD1_QUESTION1FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION1FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION2FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION2FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION3FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION3FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION4FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION4FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION5FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION5FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION6FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION6FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION7FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION7FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION8FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION8FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION9FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION9FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION10FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION10FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION11FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION11FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION12FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION12FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION13FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION13FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION14FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION14FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION15FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION15FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION16FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION16FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION17FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION17FULLWITHOUT_TAPE,
      // },
      // {
      //   HD: imageValues.BOARD1_QUESTION18FULLWITHOUT_TAPE_HD,
      //   WEBP: imageValues.BOARD1_QUESTION18FULLWITHOUT_TAPE,
      // },
    ]);
    setAnimationType();
  }, []);

  useEffect(() => {
    return () => {
      setFirstShow(0);
      setRandomImage("");
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setShowInfo(setInfo);
    setShowInstruction(setInstruction);
  }, [setInfo, setInstruction]);

  useEffect(() => {
    if (questionNo > 0 || showMessage || buildingCollection) showButton(false);
    else showButton(true);
  }, [questionNo, showMessage, buildingCollection]);

  useEffect(() => {
    if (questionState.length > 0) {
      questionState.map((data) => {
        if (
          data.id === questionNo &&
          questionRound - 1 === data.questionRound
        ) {
          setQuestionModal({
            questionObject: data,
            visible: true,
          });
        }
        return null;
      }, []);
    }
    if (questionRound > 6) {
      AxlTracker(
        axl,
        "All Quizes are completed",
        "All Quizes are completed",
        42,
        true
      );
    }
    if (questionNo === 4) {
      AxlTracker(axl, "Quiz is completed", "Quiz is completed", 41, true);
      setBuildingCollection(true);
      playPauseSoundState.data && collectionAddedToRoomTwoSound.play();
      setTimeout(() => {
        collectionAddedToRoomTwoSound.pause();
        playPauseSoundState.data && celebrationSound.play();
        setCollectioArea(true);
      }, 1000);
      setTimeout(() => {
        setCollectioArea(false);
        setBuildingCollection(false);
      }, 3000);

      let newArray = [],
        anotherArray = [];
      const board = Board.find((board) => board.boardName === boardName);
      if (board) {
        const questionRounds = [
          null,
          [0, 2],
          [3, 5],
          [6, 8],
          [9, 11],
          [12, 14],
          [15, 17],
        ];
        const keyRange = questionRounds[questionRound - 1];
        if (keyRange) {
          (board.collectionRoomImages || []).forEach((image, key) => {
            if (key >= keyRange[0] && key <= keyRange[1]) {
              newArray.push(image);
            }
          });
        }
        if (keyRange) {
          (board.collectionRoomImagesWithoutTap || []).forEach((image, key) => {
            if (key >= keyRange[0] && key <= keyRange[1]) {
              anotherArray.push(image);
            }
          });
        }
      }
      setCollectionImage([...collectionImage, ...newArray]);
      setCollectionImagesWithoutTape([
        ...collectionImagesWithoutTape,
        ...anotherArray,
      ]);
      setQuestionNo(0);
      setDisabled(false);
    }
  }, [
    questionNo,
    collectionImage,
    questionRound,
    questionState,
    boardName,
    collectionImagesWithoutTape,
  ]);

  useEffect(() => {
    if (showMessage === true) {
      setTimeout(() => {
        bazaarOneSound.pause();
        setQuestionNo(1);
        setShowMessage(false);
      }, 3000);
      setTimeout(() => {
        bazaarOneSound.pause();
        quizStartSound.pause();
      }, 2000);
    }
  }, [showMessage]);

  useEffect(() => {
    if (gameCompleteQuote === true) {
      const board = Board.find((board) => board.boardName === boardName);
      const fullCollectionRoom =
        board.artWorkViseRoomImages[randomArtworkState.data];

      let array = [
        fullCollectionRoom,
        ...collectionImagesWithoutTape,
        randomImage,
      ];
      setCollectionImagesWithoutTape(array);
      // collectionImagesWithoutTape.splice(0, 0, fullCollectionRoom);
      // collectionImagesWithoutTape.push();
      gameCompleteImages();

      setTimeout(() => {
        setGameCompleteQuote(false);
        setGameCompleteModal(true);
      }, 2000);
      AxlTracker(
        axl,
        "Game Completes",
        "User has completed the game",
        99,
        true
      );
    }
  }, [gameCompleteQuote, randomImage]);

  useEffect(() => {
    if (gameCompleteModal === true) {
      setTimeout(() => {
        setGameCompleteQuote(false);
        setGameCompleteModal(true);
      }, 3000);
    }
  }, [gameCompleteModal, randomArtworkState]);

  useEffect(() => {
    if (gameCompleteModal === true) {
      // collectionImage.splice(0, 0, imageValues.FULL_COLLECTION_ROOM);
      // collectionImage.push(randomImage);
      // setTimeout(() => {
      //   setGameCompleteTwo(true);
      // }, 6000);
    }
  }, [gameCompleteModal]);

  useEffect(() => {
    if (vehicleType?.length > 0) {
      const vehicle = document.getElementById(vehicleType);
      if (vehicle) {
        document.getElementById(vehicleType).outerHTML = "";
        const animationTypes = {
          car: car,
          truck: truck,
          bus: bus,
          train: train,
          aeroplane: flight,
          bus2: bus,
        };
        const updateAnimation = animationTypes[vehicleType];
        setAnimationType(updateAnimation);
        const moveArea = {
          car: [3, 4],
          truck: [4, 5],
          bus: [4, 5],
          train: [5, 6],
          aeroplane: [6, 7],
          bus2: [3, 4],
        };
        const updatePlace = moveArea[vehicleType];
        rollDice(updatePlace[0], updatePlace[1], vehicle);
      }
    }
  }, [vehicleType]);

  // This is use to set the collector on index
  const setCollector = (id) => {
    const collector = document.getElementById("collector");
    document.getElementById(id)?.appendChild(collector);
  };

  // This is used to get postion of all the vehicle
  const getVehcilePosition = () => {
    const vehiclePosition =
      Board.find((data) => data.boardName === boardName)?.typeOfVehicle.flatMap(
        (data) =>
          Object.entries(data).flatMap(([key, values]) =>
            values.map(({ position }) => ({ [key]: position }))
          )
      ) || [];

    setVehicleIndex(vehiclePosition);
  };

  // This is used to set the postion of all items
  const getId = (id) => {
    const board = Board.find((board) => board.boardName === boardName);
    if (board) {
      const elements = board.typeOfVehicle.flatMap((vehicle) => {
        return Object.keys(vehicle).flatMap((key) => {
          return vehicle[key]
            .filter((value) => value.position === id)
            .map((value, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  display: "flex",
                }}
                id={key}
              >
                <img
                  style={{
                    height: key === "door" ? 60 : 100,
                    width: key === "door" ? 50 : 100,
                    marginLeft:
                      key === "truck" ? -36 : key === "door" ? 0 : -30,
                    marginTop:
                      key === "aeroplane" ? -32 : key === "door" ? -5 : -26,
                  }}
                  src={value.image}
                  alt="VehicleImages"
                />
              </div>
            ));
        });
      });

      const markets = board.typeOfMarket
        .filter((market) => market.pos1 === id)
        .map((market, index) => (
          <MarketDiv key={index}>
            <img
              style={{
                height: market.height,
                width: market.width,
                opacity: 0.7,
              }}
              src={market.imageName}
              alt="MarketImages"
            />
            <BazaarName>
              {changeLanguageState.data === "en"
                ? market.bazaarName
                : market.bazaarNameHindi}
            </BazaarName>
          </MarketDiv>
        ));

      return [...markets, ...elements];
    }

    return null;
  };

  // This is used to roll Dice
  const rollDice = async (max = 7, min = 1, type = {}) => {
    // Works when all quizes are completed
    if (allQuizeCompleted) {
      setCount(count + 1);
      if (count === 0 || count === 1 || count === 2) min = 7;
      if (count === 3) {
        min = 3;
        max = 4;
      }
    }
    setFirstShow(firstShow + 1);
    setDisabled(true);
    let newArray = [];
    const randomNumber = generateRandomNumber(max, min);
    const collector = document.getElementById("collector");
    const parentElement = collector.parentNode;
    const parentId = parentElement.getAttribute("id");
    let finalPosition = Number(parentId) + randomNumber;
    let vehicle;

    // This is used top check vehicle
    // (Check this for position])
    vehicleIndex.filter((data) => {
      Object.values(data).map((value) => {
        if (value === finalPosition) {
          vehicle = Object.keys(data).toString();
          finalPosition = value;
        } else newArray.push(data);
        return true;
      }, []);
      return true;
    }, []);

    setVehicleIndex(newArray);
    newArray = [];
    let updateMarket = {};
    const board = Board.find((board) => board.boardName === boardName);

    // This is used to check the market
    if (board) {
      board.typeOfMarket.forEach((value) => {
        const { bazaarName, question, pos3, pos5 } = value;
        let updatedPosition = 0;
        if (finalPosition >= pos5) {
          updatedPosition = pos5;
        }
        if (finalPosition >= pos3) {
          updatedPosition = pos3;
        }
        if (updatedPosition > 0) {
          let checkOne = false;
          if (
            marketIndex?.[bazaarName]?.length &&
            marketIndex?.[bazaarName]?.length < 3
          ) {
            if (!marketIndex?.[bazaarName]?.includes(updatedPosition)) {
              newArray = [...marketIndex?.[bazaarName], updatedPosition];
              finalPosition = updatedPosition;
              checkOne = true;
            }
          } else if (!marketIndex?.[bazaarName]?.includes(updatedPosition)) {
            newArray = [updatedPosition];
            checkOne = true;
          }
          if (checkOne) {
            const questionIndex = question.findIndex(
              (q) => q.questionRound === questionRound
            );
            if (questionIndex !== -1) {
              setQuestionState(question);
              setQuestionRound(questionRound + 1);
              finalPosition = updatedPosition;
              updateMarket = { [bazaarName]: newArray };
              vehicle = "";
            }
          }
        }
      });
    }
    if (Object.keys(updateMarket).length > 0) {
      setMarketIndex({
        ...marketIndex,
        ...updateMarket,
      });
    }

    let currentRow = Math.floor((parentId - 1) / 8);
    let currentCol =
      currentRow % 2 === 0 ? (parentId - 1) % 8 : 7 - ((parentId - 1) % 8);
    let nextRow = Math.floor((finalPosition - 1) / 8);
    let nextCol =
      nextRow % 2 === 0
        ? (finalPosition - 1) % 8
        : 7 - ((finalPosition - 1) % 8);
    let xOne = 0;
    let yOne = 0;
    let xTwo = 0;
    if (currentRow !== nextRow) {
      const isCurrentRowEven = currentRow % 2 === 0;
      const isNextRowOdd = nextRow % 2 !== 0;
      const nextColCheck = (finalPosition - 1) % 8;
      xOne = isCurrentRowEven ? (7 - currentCol) * 46 : currentCol * -46;
      yOne = -46;
      if (isNextRowOdd && nextColCheck !== 0) {
        xTwo = xOne - nextColCheck * 46;
      } else if (!isNextRowOdd && nextColCheck !== 0) {
        xTwo = xOne + nextColCheck * 46;
      }
    } else {
      xOne = (nextCol - currentCol) * 48;
      yOne = 0;
    }

    setTimeout(() => {
      let updateAnimationSound;
      kaudiOneSound.pause();
      setShowKaudiAnimation(false);
      if (finalPosition <= 64) {
        setAxis({
          translateXOne: xOne - 2,
          translateXTwo: xTwo,
          translateYOne: yOne,
        });
        if (vehicleType?.length > 0) {
          const animationTypes = {
            car: carSound,
            truck: truckSound,
            bus: busSound,
            train: trainSound,
            aeroplane: planeSound,
            bus2: busSound,
          };
          updateAnimationSound = animationTypes[vehicleType];
          setVehcileType();
        } else {
          updateKaudiImage(finalPosition, parentId);
          updateAnimationSound = walkingSound;
          getRollDiceText();
        }
        playPauseSoundState.data && updateAnimationSound.play();
        setMovingAnimation(true);
        setTimeout(() => {
          updateAnimationSound.pause();
          setAnimationType();
          setMovingAnimation(false);

          if (Object.keys(updateMarket).length > 0) {
            if (playPauseSoundState.data) {
              quizStartSound.play();
              // bazaarOneSound.play();
            }
            setShowMessage(true);
          }

          if (Object.keys(type).length > 0) {
            const finalPositionElement = document.getElementById(finalPosition);
            if (finalPositionElement) {
              finalPositionElement.appendChild(type);
            }
          }

          if (isiOS) {
            setTimeout(() => {
              setVehcileType(vehicle);
            }, 100);

            setTimeout(() => {
              const finalPositionElement =
                document.getElementById(finalPosition);
              if (finalPositionElement) {
                finalPositionElement.appendChild(collector);
              }
            }, 50);
          } else {
            const finalPositionElement = document.getElementById(finalPosition);
            if (finalPositionElement) {
              finalPositionElement.appendChild(collector);
            }
            setVehcileType(vehicle);
          }

          if (finalPosition === 64) {
            setGameCompleteQuote(true);
          }

          setDisabled(false);
        }, 2000);
      } else setDisabled(false);
    }, 1000);
  };

  //This is used to update kaudi Image
  const updateKaudiImage = (finalPosition, parentId) => {
    const kaudiValues = [
      imageValues.ROLLZERO,
      imageValues.ROLLONE,
      imageValues.ROLLTWO,
      imageValues.ROLLTHREE,
      imageValues.ROLLFOUR,
      imageValues.ROLLFIVE,
      imageValues.ROLLSIX,
    ];
    const kaudiValue =
      kaudiValues[Math.min(Math.max(finalPosition - parentId, 0), 6)];
    setKaudiImage(kaudiValue);
  };

  // This is used to render images collection in the room
  const collectionImageComponents = useMemo(() => {
    return collectionImage.map((image, index) => {
      return (
        <RoomCollectionImage
          key={index}
          src={image}
          alt={`Collection Image ${index}`}
          top={postion[index].top}
          left={postion[index].left}
          index={index}
          show={showInfo}
        />
      );
    });
  }, [collectionImage, postion]);

  // This is used to get random text
  const getRollDiceText = () => {
    const randomIndex = Math.floor(
      Math.random() * rollDiceTextValue[changeLanguageState.data].length
    );
    const text = rollDiceTextValue[changeLanguageState.data][randomIndex];
    rollDiceTextValue[changeLanguageState.data].splice(randomIndex, 1);
    setRollDiceText(text);
  };

  const gameCompleteImages = () => {
    return !downloadImage ? (
      <>{stringValues[changeLanguageState.data].fullCollection}</>
    ) : collectedImageId !== 0 && collectedImageId !== 19 ? (
      <>{stringValues[changeLanguageState.data].matchboxCollection}</>
    ) : collectedImageId === 19 ? (
      <>{stringValues[changeLanguageState.data].collectibleArtwork}</>
    ) : (
      <>{stringValues[changeLanguageState.data].fullCollection}</>
    );
  };

  // This is used to change Language
  // const dropdownLanguageView = () => {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         gap: "15px",
  //         backgroundColor: "rgb(70, 48, 72)",
  //         position: "absolute",
  //         top: isMobileView ? "170px" : "auto",
  //         left: isMobileView ? "127px" : "30px",
  //         right: "auto",
  //         bottom: isMobileView ? "auto" : "130px",
  //         width: "100px",
  //         paddingTop: "20px",
  //         paddingBottom: "20px",
  //       }}
  //     >
  //       <ModalButton onClick={() => changeLanguage("en")}>English</ModalButton>
  //       <ModalButton onClick={() => changeLanguage("hi")}>Hindi</ModalButton>
  //       <ModalButton onClick={() => changeLanguage("ta")}>Tamil</ModalButton>
  //     </div>
  //   );
  // };

  const switchLanguage = () => {
    return changeLanguageState.data === "en"
      ? changeLanguage("hi")
      : changeLanguage("en");
  };

  const onChangeImage = (id) => {
    setCollectedImageId(id);
    const result = collectionImagesWithoutTape[id];
    setDownloadImage(result.HD);
  };

  // const download = async () => {
  //   const browser = checkBrowser();
  //   if (!downloadImage) {
  //     const result = collectionImagesWithoutTape[0];
  //     if (browser === "browser") {
  //       saveAs(result.HD, "collection.jpeg");
  //     } else {
  //       try {
  //         const base64 = await loadImage(result.HD);
  //         axl.sendMessage(AxL.ChildToHost.SHARE, {
  //           files: [
  //             {
  //               data: base64,
  //               name: "collection.jpeg",
  //               type: "image/jpeg",
  //               title: "artwork",
  //             },
  //           ],
  //         });
  //       } catch (error) {
  //         console.error("Error downloading the image:", error);
  //       }
  //     }
  //   } else {
  //     if (downloadImage) {
  //       saveAs(downloadImage, "collection.jpeg");
  //     } else {
  //       try {
  //         const base64 = await loadImage(downloadImage);
  //         axl.sendMessage(AxL.ChildToHost.SHARE, {
  //           files: [
  //             {
  //               data: base64,
  //               name: "collection.jpeg",
  //               type: "image/jpeg",
  //               title: "artwork",
  //             },
  //           ],
  //         });
  //       } catch (error) {
  //         console.error("Error downloading the image:", error);
  //       }
  //     }
  //   }
  // };

  const download = () => {
    const browser = checkBrowser();
    const commonButtonProps = {
      onClick: () => {
        playSound(playPauseSoundState);
        getImage(browser === "browser" ? 1 : 2);
        AxlTracker(axl, "Clicked on Download", "Download Image", 23, true);
      },
      style: {
        backgroundColor: "#E9BE2F",
        height: 40,
        width: 40,
        marginTop: 30,
      },
      title: stringValues[changeLanguageState.data].downloadText,
    };
    const buttonContent = <img src={data[2]} alt="ButtonsImage" />;

    if (
      (browser === "browser" && AxL.can.download === true) ||
      (browser === "WebView" && AxL.can.shareFiles === true)
    ) {
      return <Buttons {...commonButtonProps}>{buttonContent}</Buttons>;
    }
  };

  const getImage = async (img) => {
    try {
      const fileName = "collection.jpeg";
      const imageToDownload =
        downloadImage || collectionImagesWithoutTape[0].HD;

      if (img === 1) {
        saveAs(imageToDownload, fileName);
      } else {
        const base64 = await loadImage(imageToDownload);
        axl.sendMessage(AxL.ChildToHost.SHARE, {
          title: stringValues[changeLanguageState.data].buildYourOwnMatchbox,
          files: [
            {
              data: base64,
              name: "collection.jpeg",
              type: "image/jpeg",
            },
          ],
        });
      }
    } catch (error) {
      console.error("Error downloading the image:");
    }
  };

  const AxlShare = async () => {
    axl.sendMessage(AxL.ChildToHost.SHARE, {
      title: stringValues[changeLanguageState.data].buildYourOwnMatchbox,
    });
  };

  useEffect(() => {
    if (firstShow === 1 && !disabled) {
      vehicleType
        ? setTimeout(() => {
            setOnClickFirstTime(true);
          }, 2600)
        : setOnClickFirstTime(true);
    }
  }, [firstShow, disabled]);

  const getQuizeState = (e) => {
    setAllQuizeCompleted(true);
  };

  return (
    <>
      {questionModal.visible===false && mobileWidth < 1080 && questionNo===0 && !showMessage &&(
        <OuterDiv>
          <Button
            onClick={() => {
              setShowInfo(true);
              getInfo(true);
              playSound(playPauseSoundState);
              AxlTracker(
                axl,
                "Clicked on Information",
                "Hide and Unhide",
                10,
                true
              );
            }}
            title="Information"
          >
            <ButtonImg src={imageValues.INFORMATION} />
          </Button>

          <Button
            onClick={() => {
              // SetshowDropDownLanguage(!showDropDownLanguage);
              switchLanguage();
              playSound(playPauseSoundState);
              AxlTracker(
                axl,
                "Clicked on Language",
                "Language Switch",
                9,
                true
              );
            }}
            title="Language"
          >
            <ButtonImg src={imageValues.LANGUAGE} />
          </Button>

          <Button
            onClick={() => {
              playPauseSound(!playPauseSoundState.data);
              playSound(playPauseSoundState);
              AxlTracker(axl, "Clicked on Volume", "Mute and Unmute", 13, true);
            }}
            title="Sound"
          >
            {playPauseSoundState.data ? (
              <ButtonImg src={imageValues.VOLUMEON} />
            ) : (
              <ButtonImg src={imageValues.VOLUMEOOF} />
            )}
          </Button>

          <Button
            onClick={() => {
              AxlShare();
              playSound(playPauseSoundState);
              AxlTracker(axl, "Clicked on Share", "Share", 97, true);
            }}
            title="Share"
          >
            <ButtonImg src={imageValues.SHAREBUTTON} />
          </Button>

          <Button
            onClick={() => {
              playSound(playPauseSoundState);
              setShowInstruction(true);
              getInstruction(true);
              AxlTracker(
                axl,
                "Clicked on Instruction",
                "Hide and Unhide",
                17,
                true
              );
            }}
            title="Instructions"
          >
            <ButtonImg src={imageValues.INSTRUCTION} />
          </Button>

          <Button
            onClick={() => {
              playSound(playPauseSoundState);
              AxlTracker(axl, "Clicked on Restart", "Game Restarts", 16, true);
              onGameComplete();
            }}
            title="Restart"
          >
            <ButtonImg src={imageValues.RESTART} />
          </Button>
        </OuterDiv>
      )}

      <Container>
        <ContainerTwo>
          <RoomParentDiv
            style={{
              zIndex: buildingCollection ? 1 : 0,
              top: 0,
              display:
                (showInfo || showInstruction, onClickFirstTime) && "none",
            }}
          >
            <RoomImage
              src={
                changeLanguageState.data === "en"
                  ? imageValues.COLLECTORROOMNEWEST
                  : imageValues.ROOMHINDI
              }
            />

            <CollectionImage>
              <ImageStyle src={randomImage.WEBP} />
              {collectionImageComponents}
            </CollectionImage>
          </RoomParentDiv>
          {gameCompleteQuote && (
            <div>
              <Message
                label={values[changeLanguageState.data].gameCompleteQuote}
                style={{
                  left: 40,
                  height: 30,
                  zIndex: 1,
                  position: "absolute",
                }}
              />
            </div>
          )}
          {mobileWidth > 1080 ? (
            <MatchBoxStrip src={imageValues.MATCHBOXSTRIP} />
          ) : (
            // <MatchBoxStripArea
            //   style={{
            //     display:
            //       (showInfo || showInstruction || onClickFirstTime) && "none",
            //   }}
            // >
            //   <MatchBoxStrip src={imageValues.MATCHBOXSTRIPCATEGORYTOP} />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Restart",
            //         "Game Restarts",
            //         16,
            //         true
            //       );
            //       onGameComplete();
            //     }}
            //     style={{
            //       left: 14,
            //     }}
            //     title={stringValues[changeLanguageState.data].restart}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       playSound(playPauseSoundState);
            //       setShowInstruction(true);
            //       getInstruction(true);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Instruction",
            //         "Hide and Unhide",
            //         17,
            //         true
            //       );
            //     }}
            //     style={{
            //       right: 174,
            //     }}
            //     title={stringValues[changeLanguageState.data].instruction}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       setShowInfo(true);
            //       getInfo(true);
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Information",
            //         "Hide and Unhide",
            //         10,
            //         true
            //       );
            //     }}
            //     style={{
            //       marginRight: 15,
            //     }}
            //     title={stringValues[changeLanguageState.data].info}
            //   />
            // </MatchBoxStripArea>
            <MatchBoxStrip src={imageValues.MATCHBOXSTRIP} />
          )}
          <GamePad
            style={{
              display:
                (showInfo || showInstruction || onClickFirstTime) && "none",
            }}
          >
            <Door src={imageValues.MATCHBOX_DOOR_2} />

            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={64 - (key - 1) - 1} className="box">
                  {getId(64 - (key - 1) - 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={48 + key + 1} className="box">
                  {getId(48 + key + 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={48 - (key - 1) - 1} className="box">
                  {getId(48 - (key - 1) - 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={32 + key + 1} className="box">
                  {getId(32 + key + 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={32 - (key - 1) - 1} className="box">
                  {getId(32 - (key - 1) - 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={16 + key + 1} className="box">
                  {getId(16 + key + 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={16 - (key - 1) - 1} className="box">
                  {getId(16 - (key - 1) - 1)}
                </Box>
              );
            }, [])}
            {[...Array(numberOfBox)].map((e, key) => {
              return (
                <Box key={key} id={key + 1} className="box">
                  {getId(key + 1)}
                </Box>
              );
            }, [])}
            <div
              style={{
                position: "absolute",
                animation: "collectorMove 2s ease-in-out 0s forwards",
                zIndex:
                  initialState ||
                  gameCompleteModal ||
                  buildingCollection ||
                  showMessage ||
                  showInfo ||
                  onClickFirstTime ||
                  questionNo > 0
                    ? 0
                    : 1,
              }}
              id="collector"
              className="collect"
            >
              {animationType ? (
                <LottieAnimation
                  animationData={animationType}
                  loop={false}
                  style={{ height: 114, width: 114, marginTop: 6 }}
                  info={showInfo}
                />
              ) : (
                <LottieAnimation
                  info={showInfo}
                  animationData={thinking}
                  loop={true}
                />
              )}
            </div>
            {/* {showDropDownLanguage && dropdownLanguageView()} */}
          </GamePad>
          {mobileWidth > 1080 ? (
            <MatchBoxStrip src={imageValues.MATCHBOXSTRIP} />
          ) : (
            // <MatchBoxStripArea
            //   style={{
            //     display:
            //       (showInfo || showInstruction || onClickFirstTime) && "none",
            //   }}
            // >
            //   <MatchBoxStrip
            //     src={
            //       playPauseSoundState.data
            //         ? imageValues.MATCHBOXSTRIPAUDIOONSHARELANGUAGE
            //         : imageValues.MATCHBOXSTRIPAUDIOOFFSHARELANGUAGE
            //     }
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       // SetshowDropDownLanguage(!showDropDownLanguage);
            //       switchLanguage();
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Language",
            //         "Language Switch",
            //         9,
            //         true
            //       );
            //     }}
            //     style={{
            //       left: 14,
            //     }}
            //     title={stringValues[changeLanguageState.data].language}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       AxlShare();
            //       playSound(playPauseSoundState);
            //       AxlTracker(axl, "Clicked on Share", "Share", 97, true);
            //     }}
            //     style={{
            //       right: 174,
            //     }}
            //     title={stringValues[changeLanguageState.data].share}
            //   />
            //   <MatchBoxStripButton
            //     onClick={() => {
            //       playPauseSound(!playPauseSoundState.data);
            //       playSound(playPauseSoundState);
            //       AxlTracker(
            //         axl,
            //         "Clicked on Volume",
            //         "Mute and Unmute",
            //         13,
            //         true
            //       );
            //     }}
            //     style={{
            //       marginRight: 15,
            //     }}
            //     title={stringValues[changeLanguageState.data].sound}
            //   />
            // </MatchBoxStripArea>
            <MatchBoxStrip src={imageValues.MATCHBOXSTRIP} />
          )}
          <BottomView
            style={{
              display:
                (showInfo || showInstruction || onClickFirstTime) && "none",
            }}
          >
            <DiceButton
              onClick={() => {
                setKaudiTap(kaudiTap + 1);
                setInitialState(kaudiTap > 0 ? false : true);
                rollDice(6);
                if (playPauseSoundState.data) {
                  kaudiOneSound.play();
                }
                setShowKaudiAnimation(true);
                AxlTracker(
                  axl,
                  "Clicked on Kaudi",
                  "User started game",
                  30,
                  true
                );
              }}
              disabled={disabled}
              style={{
                zIndex:
                  initialState &&
                  (showInfo || showInstruction || onClickFirstTime) === false
                    ? 1
                    : 0,
              }}
              showAnimation={
                (showInfo || showInstruction || onClickFirstTime) === false &&
                disabled === false
                  ? true
                  : false
              }
            >
              {showKaudiAnimation ? (
                <LottieAnimation
                  animationData={kaudiAnimation}
                  style={{ height: 75, width: 72 }}
                />
              ) : (
                <KaudiImage src={kaudiImage} />
              )}
            </DiceButton>
            <BottomTextArea>
              {(initialState || !rollDiceText) &&
              (showInfo || showInstruction || onClickFirstTime) === false ? (
                <BottomTextTwo style={{ zIndex: 1, backgroundImage: 0 }}>
                  {values[changeLanguageState.data].tapCowrieToStart}
                </BottomTextTwo>
              ) : (
                <BottomText>{rollDiceText}</BottomText>
              )}
            </BottomTextArea>
          </BottomView>
          {showMessage && (
            <TransparentBackground>
              <ShowMessageSection>
                <LottieAnimation
                  animationData={thinking}
                  style={{
                    height: 150,
                    width: 150,
                    marginTop: -50,
                    marginBottom: 20,
                  }}
                />
                <TutorialContentArea>
                  {values[changeLanguageState.data].gameQuizTitle}
                </TutorialContentArea>
              </ShowMessageSection>
            </TransparentBackground>
          )}
          {questionNo > 0 ? (
            <TransparentBackground>
              {questionModal.visible ? (
                <QuestionModal
                  onClose={() => setQuestionNo(0)}
                  questionNo={questionNo}
                  onQuestionChange={() => {
                    setQuestionModal({
                      questionObject: {},
                      visible: false,
                    });
                    setQuestionNo(questionNo + 1);
                  }}
                  questionObject={questionModal.questionObject}
                  gameQuizes={getQuizeState}
                />
              ) : (
                <></>
              )}
            </TransparentBackground>
          ) : (
            <></>
          )}
          {gameCompleteModal && (
            <TransparentBackground
              style={{
                display:
                  showInfo || showInstruction || onClickFirstTime
                    ? "none"
                    : "flex",
                flexDirection: "column",
                height: "67.2 %",
                bottom: 0,
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <img
                src={imageValues.COLLECTORROOMVERTICALIMAGE}
                style={{
                  position: "absolute",
                  top: 60,
                  height: 530,
                }}
                alt="Main Image"
              />
              <Carousel
                className="carouselGame"
                animation="slide"
                navButtonsAlwaysVisible
                indicators={false}
                autoPlay={false}
                onChange={(id) => onChangeImage(id)}
                next={() =>
                  AxlTracker(
                    axl,
                    "Clicked on Next Arrow to view the collected images",
                    "Game Completed",
                    38,
                    true
                  )
                }
                prev={() =>
                  AxlTracker(
                    axl,
                    "Clicked on Previous Arrow to view the collected images",
                    "Game Completed",
                    39,
                    true
                  )
                }
                PrevIcon={
                  <img
                    src={imageValues.LEFTARROW}
                    height={30}
                    width={30}
                    alt="LeftArrowImage"
                    style={{
                      marginLeft: -16,
                    }}
                  />
                }
                NextIcon={
                  <img
                    src={imageValues.LEFTARROW}
                    height={30}
                    width={30}
                    style={{
                      transform: "rotate(180deg)",
                      marginRight: -16,
                    }}
                    alt="QuizImage"
                  />
                }
                navButtonsProps={{
                  style: {
                    backgroundColor: "transparent",
                  },
                }}
              >
                {collectionImagesWithoutTape.map((image, index) => (
                  <Paper
                    sx={{
                      p: "75px",
                      height: 150,
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      backgroundColor: "transparent",
                    }}
                    key={index}
                    square={true}
                  >
                    <img
                      id={image.WEBP}
                      src={image.WEBP}
                      alt={`Slide ${index}`}
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    />
                  </Paper>
                ))}
              </Carousel>
              <div
                style={{
                  position: "absolute",
                  top: "40px",
                }}
              >
                <P isEnglish={changeLanguageState.data === "en" ? true : false}>
                  {gameCompleteImages()}
                </P>
                <Para isEnglish ={stringValues[changeLanguageState.data] ==="en"}>
                  {stringValues[changeLanguageState.data].clickOnTheArrows}
                  {stringValues[changeLanguageState.data].saveAndShare}
                </Para>
              </div>
              <Div>
                {download()}
                <Buttons
                  onClick={() => {
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked Share button",
                      "Sharing Image",
                      24,
                      true
                    );
                    AxlShare();
                  }}
                  style={{
                    backgroundColor: "#E9BE2F",
                    height: 40,
                    width: 40,
                    marginTop: 30,
                  }}
                  title="Share"
                >
                  <img src={data[1]} alt="ButtonsImage" />
                </Buttons>
              </Div>
              <TextDiv
                onClick={() => {
                  axl.sendMessage(
                    AxL.ChildToHost.NAVIGATE,
                    "https://artsandculture.google.com/story/a-little-box-of-lights-tasveer-ghar/yQUxmdhlde8AJw?hl=en"
                  );
                }}
              >
                {values[changeLanguageState.data].creditMessage}
              </TextDiv>

              <ContainerDiv>
                {mobileWidth > 1080 ? (
                  <></>
                ) : (
                  <Buttons
                    onClick={() => {
                      playSound(playPauseSoundState);
                      onGameComplete();
                      AxlTracker(
                        axl,
                        "Clicked Reload button",
                        "Reload Game",
                        24,
                        true
                      );
                    }}
                    style={{
                      backgroundColor: "#E9BE2F",
                      height: 40,
                      width: 40,
                      marginTop: 40,
                    }}
                    title={stringValues[changeLanguageState.data].reload}
                  >
                    <img src={data[3]} alt="ButtonsImage" />
                  </Buttons>
                )}
              </ContainerDiv>
            </TransparentBackground>
          )}
          {/* {showInfo && (
            <Information
              onClick={() => {
                setShowInfo(false);
                getInfo(false);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Information",
                  "Hide and Unhide",
                  10,
                  true
                );
              }}
            />
          )} */}
          {showInstruction && (
            <Instruction
              onClick={() => {
                setShowInstruction(false);
                getInstruction(false);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Instruction",
                  "Hide and Unhide",
                  17,
                  true
                );
              }}
              changeLanguage={() => {
                switchLanguage();
                playSound(playPauseSoundState);
                AxlTracker(axl, "Clicked on Language", "Language Switch", 4, true);
              }}
              playPauseSound={() => {
                playPauseSound(!playPauseSoundState.data);
                playSound(playPauseSoundState);
                AxlTracker(axl, "Clicked on Volume", "Mute and Unmute", 11, true);
              }}
              onClickShare={() => {
                AxlShare();
                playSound(playPauseSoundState);
                AxlTracker(axl, "Clicked on Share", "Share", 66, true);
              }}
            />
          )}
          {buildingCollection && (
            <TransparentBackground>
              <CollectionArea>
                {collectioArea ? (
                  <>
                    <TutorialContentArea2>
                      {collectionImage.length !== 18 ? (
                        <p>
                          {values[changeLanguageState.data].textAfterQuizOne}{" "}
                          {18 - collectionImage.length}
                          {values[changeLanguageState.data].textAfterQuizTwo}
                        </p>
                      ) : (
                        <p>
                          {
                            stringValues[changeLanguageState.data]
                              .allCollectibles
                          }
                        </p>
                      )}
                    </TutorialContentArea2>
                    <LottieAnimation
                      animationData={thinking}
                      style={{ width: 170, height: 170 }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </CollectionArea>
            </TransparentBackground>
          )}
          {onClickFirstTime && (
            <FiddleOne
              showInfo={showInfo}
              onClick={() => {
                playSound(playPauseSoundState);
                // onChange();
                setOnClickFirstTime(false);
                AxlTracker(
                  axl,
                  "Clicked on Continue Collecting",
                  "Continue Collecting",
                  18,
                  true
                );
              }}
              boardName={boardName}
              // onDownload={onDownload}
              changeLanguage={() => {
                // SetshowDropDownLanguage(!showDropDownLanguage);
                switchLanguage();
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Language",
                  "Language Switch",
                  4,
                  true
                );
              }}
              onInformation={() => {
                setShowInfo(true);
                getInfo(true);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Information",
                  "Hide and Unhide",
                  10,
                  true
                );
              }}
              playPauseSound={() => {
                playPauseSound(!playPauseSoundState.data);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Volume",
                  "Mute and Unmute",
                  13,
                  true
                );
              }}
              onInstruction={() => {
                playSound(playPauseSoundState);
                setShowInstruction(true);
                getInstruction(true);
                AxlTracker(
                  axl,
                  "Clicked on Instruction",
                  "Hide and Unhide",
                  17,
                  true
                );
              }}
              onRestart={() => {
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Restart",
                  "Game Restarts",
                  16,
                  true
                );
                onGameComplete();
              }}
            />
          )}
        </ContainerTwo>
        {movingAnimation && (
          <style>
            {`
          @keyframes collectorMove {
            50%{
              transform:  translate(${axis.translateXOne}px, 0px);
            }
            75%{
               transform:translate(${axis.translateXOne}px,${
              axis.translateYOne
            }px)
            }
            100%{
            ${
              axis.translateXTwo !== 0
                ? `transform:   translate(${axis.translateXTwo}px, ${axis.translateYOne}px)`
                : `transform:  translate(${axis.translateXOne}px,${axis.translateYOne}px)`
            }
             }
          `}
          </style>
        )}
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
  randomArtworkState: state.randomArtwork,
});

const mapDispatchToProps = (dispatch) => ({
  playPauseSound: (params) => dispatch(playPauseSound(params)),
  changeLanguage: (params) => dispatch(changeLanguage(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Game);
